import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AddendumPageUI from './AddendumPageUI'

class AddendumPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      addendumAdded: false
    }
  }

  render() {
    return (
      <AddendumPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        onRefreshClick={this.onRefreshClick}
        //
        addendumAdded={this.state.addendumAdded}
        onAddAddendum={this.onAddAddendum}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  onAddAddendum = () => {
    this.setState({
      addendumAdded: true
    })
    RestApiUtils.post(this.props.context,
      `/api/su/loans/${this.props.match.params.loanId}/addendum`,
      this.onAddAddendumCallback, {}
    )
  }

  onAddAddendumCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      addendumAdded: false,
      addAddendumErrorList: errorList,
      addAddendumSuccessMsg: response.success
    })

    this.onRefreshClick('noBusy')

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          addAddendumSuccessMsg: null,
        })
      }, 5000)
    }
  }

  onRefreshClick = (noBusy) => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
    }
    else {
      this.setState({
        loan: null,
        errorList: null,
      }, () => {
        this.getLoan(context)
      })
    }
  }
}

export default withRouter(AddendumPageSF)
